// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"f46830e7","107":"f32cc675","277":"9a160291","306":"4f4c7bf2","439":"ea82b75a","646":"108e146b","750":"95fde4b4","762":"4a52aee4","929":"b95ef1d1"}[chunkId] + ".chunk.js";
};